/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ProfessionalTitleEnum {
	NotApplicable = "NotApplicable",
	TeachingAssistant = "TeachingAssistant",
	Lecturer = "Lecturer",
	AssociatedProfessor = "AssociatedProfessor",
	Professor = "Professor",
}

export function ProfessionalTitleEnumFromJSON(
	json: any
): ProfessionalTitleEnum {
	return ProfessionalTitleEnumFromJSONTyped(json, false);
}

export function ProfessionalTitleEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ProfessionalTitleEnum {
	return json as ProfessionalTitleEnum;
}

export function ProfessionalTitleEnumToJSON(
	value?: ProfessionalTitleEnum | null
): any {
	return value as any;
}
